import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconDirective } from '@coreui/icons-angular';
import { I18nService, TranslatePipe } from 'i18n';

/**
 * "Need help? — Support": the one entry point a member must find on every page
 * (customer principle 5, 2026-09-21). Rendered by the shared header through
 * HEADER_ACTION_COMPONENT (see app.config.ts); on phones the header hides the
 * label and the dashboard's floating button takes over.
 */
@Component({
  selector: 'gh-support-header-action',
  standalone: true,
  imports: [RouterLink, IconDirective, TranslatePipe],
  template: `
    <a class="gh-support-btn" [routerLink]="['/', lang, 'support']">
      <svg cIcon name="cilSpeech" size="sm"></svg>
      <span class="gh-support-btn__label">{{ 'support_hub.header_button' | translate }}</span>
    </a>
  `,
  styles: [`
    :host { display: inline-flex; align-items: center; margin-inline-end: .5rem; }
    .gh-support-btn {
      display: inline-flex; align-items: center; gap: .5rem;
      padding: .5rem 1rem; border-radius: 999px;
      background: var(--gh-green-action, #0E8F5E); color: #fff;
      font-weight: 700; font-size: .78rem; letter-spacing: .06em; text-transform: uppercase;
      text-decoration: none; box-shadow: 0 6px 18px rgba(14, 143, 94, .25);
      white-space: nowrap;
    }
    .gh-support-btn:hover { background: var(--gh-green-action-hover, #0B7A50); color: #fff; }
    @media (max-width: 767.98px) {
      .gh-support-btn { padding: .5rem; }
      .gh-support-btn__label { display: none; }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportHeaderActionComponent {
  private i18n = inject(I18nService);
  get lang(): string { return this.i18n.getLanguage(); }
}
